import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Row, Col, Button, Modal, Upload, Spin, Input, notification, Divider, Select, Avatar, Tooltip } from 'antd';
import config from '../../config';
import * as userActions from '../../redux/actions/userActions';
import { InfoCircleOutlined, FileImageOutlined } from '@ant-design/icons';
import {
  getBase64,
  confirmationModal,
  onlyNumbers,
  formItemLayout,
  tailFormItemLayout,
  unexpectedError,
  handleBackendFormErrors,
  onlyNumber,
  beforeUpload,
} from '../../common_functions';
import UploadTrigger from '../../common_functions/UploadTrigger';

const PhyChar = props => {
  const dispatch = useDispatch();
  const formCharRef = useRef(null);
  const [conv, setConv] = useState();
  const [convHeight, setConvHeight] = useState();
  const [convSheet, setConvSheet] = useState();
  const [convHeightSheet, setConvHeightSheet] = useState();
  const [convMount, setConvMount] = useState();
  const [convHeightMount, setConvHeightMount] = useState();
  const [loading, setLoading] = useState(false);
  const [newThumbnail, setThumbnail] = useState();
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [negativeThumbnail, setNegativeThumbnail] = useState(null);
  const [signatureData, setSignatureData] = useState([]);
  const [annotationData, setAnnotationData] = useState([]);
  const [phyData, setPhyData] = useState();
  const [stampData, setStampData] = useState([]);
  const [filteredStampData, setFilteredStampData] = useState([]);
  const [mountingData, setMountingData] = useState([]);
  const [printConditions, setPrintConditions] = useState([]);
  const [childStamps, setChildStamps] = useState([]);
  const [filteredChildStamps, setFilteredChildStamp] = useState([]);
  const handleCancel = () => setPreviewVisible(false);
  const propertiesToCheck = [
    { property: 'image_dimension_width', key: 'conv' },
    { property: 'image_dimension_height', key: 'convHeight' },
    { property: 'sheet_dimension_width', key: 'convSheet' },
    { property: 'sheet_dimension_height', key: 'convHeightSheet' },
    { property: 'mount_dimension_width', key: 'convMount' },
    { property: 'mount_dimension_height', key: 'convHeightMount' },
  ];
  let saveAndNext = '';

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const sData = await getStamps();

        const { data: signData } = await dispatch(
          userActions.getItems('signatures', {
            fields: ['id', 'signature'],
            limit: -1,
          })
        );
        const { data: aData } = await dispatch(
          userActions.getItems('annotation_materials', {
            fields: ['id', 'name'],
            limit: -1,
          })
        );
        const { data: mountData } = await dispatch(
          userActions.getItems('mounting_methods', {
            fields: ['id', 'methods'],
            limit: -1,
          })
        );
        const { data: printConditionsData } = await dispatch(
          userActions.getItems('print_condition', {
            fields: ['id', 'condition', 'desc'],
            limit: -1,
          })
        );
        setStampData(sData);
        setFilteredStampData(sData);
        setSignatureData(signData);
        setAnnotationData(aData);
        setMountingData(mountData);
        setPrintConditions(printConditionsData);
        const { data } = await dispatch(
          userActions.getItem('print', props.print, {
            fields: [
              'id,negative_id.thumbnail,thumbnail.id,thumbnail.filename_download,image_dimension_width,image_dimension_height,sheet_dimension_width',
              'sheet_dimension_height,condition_notes,mount_dimension_width,mount_dimension_height,stamp_dimension_height',
              'standard_city_line_width,standard_name_line_width,standard_stamp_height,city_line_width,name_line_width',
              'c_print.acquisition,c_print.title,collection_id.name,mount_type,stamp,stamp.height,stamp.width',
              'stamp.id,stamp.parent_stamp,stamp.is_subgroup,stamp_subgroup.height,stamp_subgroup.width',
              'stamp_subgroup.id,stamp_subgroup.city_width,  signature,annotation_material,mounting_method,stamp.city_width,print_condition',
            ],
          })
        );
        const stamp = data?.stamp;
        if (stamp?.id) {
          await showSubgroup(stamp.id);
        }
        if (data?.thumbnail?.id) {
          const fileData = await dispatch(userActions.getFile(data.thumbnail.id));
          setThumbnail([
            {
              uid: data.thumbnail.id,
              name: data.thumbnail.filename_download,
              url: fileData,
            },
          ]);
        }
        setNegativeThumbnail('');
        if (data?.negative_id?.thumbnail) {
          const negativeThumbFile = await dispatch(userActions.getFile(data.negative_id.thumbnail));
          setNegativeThumbnail(negativeThumbFile);
        }
        // set mm value for follwing fields
        for (const { property, key } of propertiesToCheck) {
          if (data[property]) {
            mmValue(data[property], key);
          }
        }
        formCharRef.current.setFieldsValue({
          ...data,
          thumbnail: data?.thumbnail?.id,
          acquisition: data.c_print[0].acquisition,
          title: data.c_print[0].title,
          // standard_stamp_height: stamp?.height,
          // standard_name_line_width: stamp?.width,
          stamp: stamp?.is_subgroup ? stamp?.parent_stamp : stamp?.id,
          // standard_city_line_width: stamp?.city_width,
          // stamp_subgroup: stamp?.is_subgroup ? stamp.id : null,
          stamp_subgroup: data?.stamp_subgroup?.id,
          standard_stamp_height: data?.stamp_subgroup?.id ? data.stamp_subgroup.height : stamp?.height,
          standard_name_line_width: data?.stamp_subgroup?.id ? data.stamp_subgroup.width : stamp?.width,
          standard_city_line_width: data?.stamp_subgroup?.id ? data.stamp_subgroup.city_width : stamp?.city_width,
        });
        setPhyData(data);
      } catch (error) {
        unexpectedError(error);
      } finally {
        setLoading(false);
      }
    }
    //   fetchData();
    // }, [props.print, props.objectData.print.negative_id, props.mounting]);
    if (props.activeTab == '3') {
      fetchData();
    }
  }, [props.activeTab]);

  const handleStampSearch = (inputValue, stamps = 'parent') => {
    const filterFunction = stamps === 'child' ? childStamps : stampData;
    const setterFunction = stamps === 'child' ? setChildStamps : setFilteredStampData;
    const filteredData = filterFunction.filter(el => el.stamp_name.toLowerCase().includes(inputValue.toLowerCase()));
    setterFunction(filteredData);
  };
  const populateStampFields = (filteredList, stampID) => {
    const stampItem = filteredList.find(item => item.id === stampID);
    if (stampItem) {
      const { height, width, city_width } = stampItem;
      formCharRef.current.setFieldsValue({
        standard_stamp_height: height,
        standard_name_line_width: width,
        standard_city_line_width: city_width,
      });
    }
  };

  const populateFieldsWithStampInfo = async (stampID, stamp = 'parent') => {
    const parentStampID = formCharRef?.current?.getFieldValue('stamp');
    formCharRef.current.setFieldsValue({ standard_stamp_height: '', standard_name_line_width: '', standard_city_line_width: '' });
    if (stampID) {
      populateStampFields(stamp === 'child' ? childStamps : stampData, stampID);
      if (stamp === 'parent') {
        await showSubgroup(stampID);
      }
    } else if (!stampID) {
      if (stamp === 'child') {
        populateStampFields(stampData, parentStampID);
      }
      if (stamp === 'parent') {
        setChildStamps([]);
        setFilteredChildStamp([]);
      }
    }
  };

  const mmValue = (value, state) => {
    if (!isNaN(value)) {
      const conversionFactors = {
        conv: setConv,
        convHeight: setConvHeight,
        convSheet: setConvSheet,
        convHeightSheet: setConvHeightSheet,
        convMount: setConvMount,
        convHeightMount: setConvHeightMount,
      };
      const conversionFunction = conversionFactors[state];
      if (conversionFunction) {
        const conv = (value * 0.0393701).toFixed(2);
        conversionFunction(conv);
      }
    }
  };
  /**Handle file change**/
  const handleFileChange = ({ fileList: newFile }) => {
    setThumbnail(newFile);
  };

  const handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };

  const complete = async values => {
    Modal.destroyAll();
    values = { ...values, phy_char: 1 };
    await onSave(values);
  };
  const incomplete = async values => {
    Modal.destroyAll();
    values = { ...values, phy_char: 0 };
    await onSave(values);
  };
  let onFinish = async (values, action = null) => {
    saveAndNext = '';
    if (!!action) {
      saveAndNext = action;
    }
    await confirmationModal(values, 'Status', 'Is this record complete or incomplete?', 'Incomplete', 'Complete', complete, incomplete);
  };
  let onSave = async values => {
    console.log('values :', values);
    setLoading(true);
    // values.stamp = values?.stamp_subgroup ?? values?.stamp;
    // delete values.stamp_subgroup;
    const formData = new FormData();
    try {
      Object.entries(values).forEach(([key, value]) => {
        if (value?.fileList?.length > 0) {
          formData.append(key, value.fileList[0].originFileObj);
        } else {
          formData.append(key, value);
        }
      });
      const response = await dispatch(userActions.collectionObject(formData, 'print/print', props.print));
      if (response) {
        if (response.error) {
          Modal.warning({
            title: 'Error',
            content: response.error,
          });
        } else {
          formCharRef.current.resetFields(['thumbnail']);
          formCharRef.current.setFieldsValue({
            thumbnail: response.data.thumbnail,
          });
          notification['success']({
            message: 'Physical characteristics saved successfully!',
            duration: 2,
          });
          if (saveAndNext == '') {
            setTimeout(() => props.history.push('/print-objects', 1500));
          } else if (saveAndNext == 'next') {
            props.objectData['print'] = response.data;
            props.stampChanged('');
            props.mountingUpdate(' ');
            props.onChange(props.objectData, 'xrf', 'XRF');
          }
        }
      }
    } catch (errorResponse) {
      handleBackendFormErrors(formCharRef, errorResponse);
    } finally {
      setLoading(false);
    }
  };

  let onFinishFailed = ({ errorFields }) => {
    formCharRef.current.scrollToField(errorFields[0].name);
  };
  let backButton = () => {
    props.onChange('', '2', 'Print / Portfolio');
  };

  const handleSaveAndNext = action => {
    formCharRef.current.validateFields().then(values => {
      onFinish(values, action);
    });
  };
  const getStamps = async (isSubgroup = false, parentStamp) => {
    const { data } = await dispatch(
      userActions.getItems('stamps', {
        fields: ['id', 'stamp_name', 'picture', 'height', 'width', 'city_width'],
        limit: -1,
        filters: parentStamp
          ? { parent_stamp: { _eq: parentStamp }, is_subgroup: { _eq: isSubgroup } }
          : { is_subgroup: { _eq: isSubgroup } },
      })
    );
    const stampsWithImages = await Promise.all(
      data?.map(async stamp => {
        if (stamp?.picture) {
          const imageUrl = await dispatch(userActions.getFile(stamp.picture));
          return {
            ...stamp,
            picture: imageUrl,
          };
        }
        return stamp;
      })
    );
    return stampsWithImages;
  };
  const showSubgroup = async parentStamp => {
    let data = await getStamps(true, parentStamp);
    if (data?.length > 0) {
      formCharRef.current.setFieldsValue({ stamp_subgroup: null });
    }
    setChildStamps(data);
    setFilteredChildStamp(data);
  };
  return (
    <Spin spinning={loading} size="large">
      <div className="artist">
        <Form
          ref={formCharRef}
          layout="vertical"
          {...formItemLayout}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={{ layout: tailFormItemLayout }}
          encType="multipart/form-data"
        >
          <Row gutter={24}>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Row gutter={24}>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Form.Item name="title">
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Form.Item name="acquisition">
                    <Input disabled />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
              {!!negativeThumbnail ? (
                <img alt="Not available" style={{ width: 170 }} src={negativeThumbnail}></img>
              ) : (
                <p>
                  <InfoCircleOutlined style={{ fontSize: 15 }} /> <span style={{ marginLeft: 5 }}>Negative thumbnail not available!</span>
                </p>
              )}
            </Col>
          </Row>
          <Divider />
          <Row gutter={24}>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="image_dimension_height" label="Image Dimension Height" rules={[{ validator: onlyNumber }]}>
                <Input
                  onChange={e => mmValue(e.target.value, 'convHeight')}
                  onKeyPress={onlyNumbers}
                  addonBefore="mm"
                  addonAfter={convHeight ? `${convHeight} Inch` : '0.00 Inch'}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="image_dimension_width" label="Image Dimension Width" rules={[{ validator: onlyNumber }]}>
                <Input
                  onChange={e => mmValue(e.target.value, 'conv')}
                  onKeyPress={onlyNumbers}
                  addonBefore="mm"
                  addonAfter={conv ? `${conv} Inch` : '0.00 Inch'}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="sheet_dimension_height" label="Support Dimension Height" rules={[{ validator: onlyNumber }]}>
                <Input
                  onChange={e => mmValue(e.target.value, 'convHeightSheet')}
                  onKeyPress={onlyNumbers}
                  addonBefore="mm"
                  addonAfter={convHeightSheet ? `${convHeightSheet} Inch` : '0.00 Inch'}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="sheet_dimension_width" label="Support Dimension Width" rules={[{ validator: onlyNumber }]}>
                <Input
                  onChange={e => mmValue(e.target.value, 'convSheet')}
                  onKeyPress={onlyNumbers}
                  addonBefore="mm"
                  addonAfter={convSheet ? `${convSheet} Inch` : '0.00 Inch'}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="mount_dimension_height" label="Mount Dimension Height" rules={[{ validator: onlyNumber }]}>
                <Input
                  onChange={e => mmValue(e.target.value, 'convHeightMount')}
                  onKeyPress={onlyNumbers}
                  addonBefore="mm"
                  addonAfter={convHeightMount ? `${convHeightMount} Inch` : '0.00 Inch'}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="mount_dimension_width" label="Mount Dimension Width" rules={[{ validator: onlyNumber }]}>
                <Input
                  onChange={e => mmValue(e.target.value, 'convMount')}
                  onKeyPress={onlyNumbers}
                  addonBefore="mm"
                  addonAfter={convMount ? `${convMount} Inch` : '0.00 Inch'}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="mounting_method" label="Mounting Method">
                <Select
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toString().toLowerCase().includes(input.toLowerCase())}
                  placeholder="Select a mounting method"
                  style={{ textTransform: 'capitalize' }}
                >
                  {mountingData?.map(item => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.methods}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="thumbnail" label="Thumbnail">
                <Upload
                  name="file"
                  className="create_object"
                  listType="picture"
                  accept={config.FileType.imageType.toString()}
                  beforeUpload={file => {
                    return beforeUpload(file, 'image', `${phyData?.c_print?.[0]?.acquisition}.print.thumb`);
                  }}
                  onRemove={props.onRemove}
                  showUploadList={{
                    showRemoveIcon: phyData?.thumbnail ? false : true,
                  }}
                  fileList={newThumbnail}
                  onPreview={handlePreview}
                  maxCount={1}
                  multiple={false}
                  onChange={handleFileChange}
                >
                  <UploadTrigger fileType="image" />
                </Upload>
              </Form.Item>
              <Modal open={previewVisible} title={previewTitle} footer={null} onCancel={handleCancel}>
                <div style={{ textAlign: 'center' }}>
                  <img
                    alt="example"
                    style={{
                      width: '100%',
                      height: 'auto',
                      textAlign: 'center',
                    }}
                    src={previewImage}
                  />
                </div>
              </Modal>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="stamp" label="Stamp">
                <Select
                  showSearch
                  allowClear
                  virtual={false}
                  filterOption={false}
                  onSearch={handleStampSearch}
                  placeholder="Select stamp"
                  style={{ textTransform: 'capitalize' }}
                  onChange={e => populateFieldsWithStampInfo(e, 'parent')}
                >
                  {filteredStampData?.map(el => (
                    <Select.Option key={el.id} value={el.id} onMouseEnter={() => {}} onMouseLeave={() => {}}>
                      <Row justify="space-between">
                        <Col>{el.stamp_name}</Col>
                        <Col>
                          <Tooltip
                            title={
                              <div className="avatar-container">
                                <img src={el.picture} alt="Avatar" className="avatar-image" />
                              </div>
                            }
                            destroyTooltipOnHide={true}
                          >
                            {el?.picture ? (
                              <Avatar src={el.picture} shape="square" />
                            ) : (
                              <Avatar icon={<FileImageOutlined />} shape="square" />
                            )}
                          </Tooltip>
                        </Col>
                      </Row>
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {filteredChildStamps?.length > 0 && (
              <Col xs={24} sm={12} md={12} lg={12}>
                <Form.Item name="stamp_subgroup" label="Stamp Subgroup">
                  <Select
                    showSearch
                    allowClear
                    virtual={false}
                    filterOption={false}
                    onSearch={e => handleStampSearch(e, 'child')}
                    placeholder="Select stamp"
                    style={{ textTransform: 'capitalize' }}
                    onChange={e => populateFieldsWithStampInfo(e, 'child')}
                  >
                    {filteredChildStamps?.map(el => (
                      <Select.Option key={el.id} value={el.id} onMouseEnter={() => {}} onMouseLeave={() => {}}>
                        <Row justify="space-between">
                          <Col>{el.stamp_name}</Col>
                          <Col>
                            <Tooltip
                              title={
                                <div className="avatar-container">
                                  <img src={el.picture} alt="Avatar" className="avatar-image" />
                                </div>
                              }
                              destroyTooltipOnHide={true}
                            >
                              {el?.picture ? (
                                <Avatar src={el.picture} shape="square" />
                              ) : (
                                <Avatar icon={<FileImageOutlined />} shape="square" />
                              )}
                            </Tooltip>
                          </Col>
                        </Row>
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            )}
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="standard_city_line_width" label="Standard City Line Width" rules={[{ validator: onlyNumber }]}>
                <Input disabled={true} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="standard_name_line_width" label="Standard Name Line Width" rules={[{ validator: onlyNumber }]}>
                <Input disabled={true} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="standard_stamp_height" label="Standard Stamp Height" rules={[{ validator: onlyNumber }]}>
                <Input disabled={true} />
              </Form.Item>
            </Col>
            <Divider />
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="city_line_width" label="City Line Width" rules={[{ validator: onlyNumber }]}>
                <Input onKeyPress={onlyNumbers} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="name_line_width" label="Name Line Width" rules={[{ validator: onlyNumber }]}>
                <Input onKeyPress={onlyNumbers} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="stamp_dimension_height" label="Stamp Height" rules={[{ validator: onlyNumber }]}>
                <Input onKeyPress={onlyNumbers} />
              </Form.Item>
            </Col>
            <Divider />
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="signature" label="Signature">
                <Select
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                  placeholder="Select signature"
                  style={{ textTransform: 'capitalize' }}
                >
                  {signatureData?.map(el => (
                    <Select.Option key={el.id} value={el.id}>
                      {el.signature}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="annotation_material" label="Signature Material">
                <Select
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                  placeholder="Select Signature Material"
                  style={{ textTransform: 'capitalize' }}
                >
                  {annotationData?.map(el => (
                    <Select.Option key={el.id} value={el.id}>
                      {el.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="print_condition" label="Condition">
                <Select
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toString().toLowerCase().includes(input.toLowerCase())}
                  placeholder="Select a print condition"
                  style={{ textTransform: 'capitalize' }}
                >
                  {printConditions?.map(el => (
                    <Select.Option key={el.id} value={el.id}>
                      <Tooltip title={el.desc}>
                        <span>
                          {el.condition} : {el?.desc?.length > 20 ? `${el.desc.substring(0, 20)}...` : el.desc}
                        </span>
                      </Tooltip>
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="condition_notes" label="Condition Notes">
                <Input.TextArea rows={5} placeholder="Enter condition notes..." />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item {...tailFormItemLayout}>
            <Button
              type="default"
              htmlType="button"
              onClick={backButton}
              style={{
                borderColor: '#d9d9d9',
                background: '#f5f5f5',
                color: 'rgba(0, 0, 0, 0.85)',
              }}
            >
              Back
            </Button>
            {props.showButton()}
            {props.showButton() != '' ? (
              <Button className="save-btn" type="primary" style={{ margin: '0 8px' }} onClick={() => handleSaveAndNext('next')}>
                Save and Next
              </Button>
            ) : (
              ''
            )}
          </Form.Item>
        </Form>
      </div>
    </Spin>
  );
};
export default PhyChar;
